import { Tag } from "lucide-react";
import { Subscription, AppliedCoupon } from "../../types/plans";
import { formatCurrency } from "../../constants";

interface TotalDisplayProps {
  selectedPlan: Subscription;
  appliedCoupon: AppliedCoupon | null;
  pricingBreakdown: any;
  total: number;
}

export function TotalDisplay({
  selectedPlan,
  appliedCoupon,
  pricingBreakdown,
  total,
}: TotalDisplayProps) {
  const currency = selectedPlan.price.currency || "USD";

  return (
    <div
      className="mb-3 p-4 rounded-3"
      style={{
        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
        border: "1px solid #e2e8f0",
      }}
    >
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <h6 className="fw-semibold mb-1 text-dark">
            {selectedPlan.name} Plan
          </h6>
          <p className="text-muted small mb-0">Monthly subscription</p>
        </div>
        <div className="text-end">
          <div className="d-flex justify-content-between small mb-2">
            <span className="text-muted">Subtotal:</span>
            <span className="fw-medium">
              {" "}
              {formatCurrency(selectedPlan.price.amount || 0, currency)}
            </span>
          </div>
          {appliedCoupon && (
            <div className="d-flex justify-content-between small mb-2 text-success">
              <span className="d-flex align-items-center gap-1">
                <Tag size={14} />
                {appliedCoupon.code}:
              </span>
              <span className="fw-medium">
                -
                {formatCurrency(
                  pricingBreakdown?.couponDiscount || 0,
                  currency
                )}
              </span>
            </div>
          )}
          <div className="d-flex justify-content-between fw-bold border-top pt-2">
            <span className="text-dark">Total: </span>
            <span className="text-dark fs-6">
              {" "}
              {formatCurrency(total, currency)}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
